import FinancialDisplay from "./FinancialDisplay";

interface Props{
    features:any,
    rates:any
}
interface Row{
    title:string,
    value:string,
    rent:number
}

type Data = {
    title: string,
    value: string | number,
    key: string
}

type RateData = {
    title: string,
    value: string
}

const Financial = ({rates,features}: Props) => {
    const allowedFeatures = [
        'lease_type',
        'lease_term',
        'rent',
        'rent_value',
        'rent_review',
        'insurance',
        'rates',
        'costs',
        'incentive',
        'cal_price',
        'service_charge',
        'tenure',
        'cal_tenure',
        'terms',
        'vat',
        'business_rates',
    ]
    const data: Data[] = [
    ]

    allowedFeatures.forEach((key) => {
        if(features[key]){
            if(key == 'rent_review'){
                let v = `Next review date ${features[key].value}`;
                if(features[key].note){
                    v += ` - Review Pattern: ${features[key].note}`
                }
                data.push(
                    {
                        title:features[key].label,
                        value:v,
                        key:key
                    }
                )
            } else if (key == 'tenure'){
                let v = features[key].value;
                if(v) {
                    if(features[key].note){
                        v += ` -  ${features[key].note}`
                    }
                    data.push(
                        {
                            title:features[key].label,
                            value:v,
                            key:key
                        }
                    )
                }
            } else if (key === 'rent_value' && !features['rent']) {
                data.push(
                    {
                        title: features[key].label,
                        // value:features[key].value,
                        value: `Subject to contract, rental offers are invited in the region of £${features[key].value} per annum exclusive of rates, service charge, VAT (if applicable) and all other outgoings.`,
                        key: key
                    }
                )
            } else if (key !== 'rent_value') {
              data.push(
                    {
                        title:features[key].label,
                        value:features[key].value,
                        key:key
                    }
                )
            }

        }

    })

    const rateData: RateData[] = []

    if(rates && rates.length > 0){
        let r = rates[rates.length-1];
        if(r.year){
            rateData.push({
            title:"Rateable Year:",
            value:r.year
            })
        }

        if(r.rateable_value){
            rateData.push({
                title:"Rateable Value:",
                value:r.rateable_value.toLocaleString(undefined, {
                    style: "currency",
                    currency: "GBP",
                  })
            })
        }
        if(r.rates_payable){
            rateData.push({
                title:"Rates payable:",
                value:r.rates_payable.toLocaleString(undefined, {
                    style: "currency",
                    currency: "GBP",
                  })
            })
        }
        if(r.ubr_pence){
            rateData.push({
                title:"UBR:",
                value:`${r.ubr_pence}p/£`
            })
        }
    }


    if(data.length === 0 && rateData.length === 0) {
        return null;
    }
    return (
        <FinancialDisplay financialData={data} ratesData={rateData} />
    )
};

export default Financial;
